import { useEffect } from 'react';
import { IDepartments } from '../../../../../interface/interfaces';
import { getInOutDepartments } from '../utils/getInOutDepartments';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { setInDepartment, setOutDepartment, setRootDepartment } from '../arangeDepartment.slice';
import { rootState } from '../../../../../redux/store';

export const useSetDepartments = () => {
    const dispatch = useAppDispatch();
    const { departmentNetworkConnection } = useAppSelector((state: rootState) => state.departmentNetwork);
    const { rootDepartment } = useAppSelector((state: rootState) => state.arangeDepartments);

    useEffect(() => {
        // if (initialized.current) return;

        if (departmentNetworkConnection.length > 0) {
            const tempRootDepartment: IDepartments = {
                ...departmentNetworkConnection[0],
                Type: 'default',
            };

            const inDepartments = getInOutDepartments(departmentNetworkConnection, rootDepartment, 'In');
            const outDepartments = getInOutDepartments(departmentNetworkConnection, rootDepartment, 'Out');

            dispatch(setRootDepartment(tempRootDepartment));
            dispatch(setInDepartment(inDepartments));
            dispatch(setOutDepartment(outDepartments));
        }
        // initialized.current = true;
    }, [departmentNetworkConnection, rootDepartment.In, rootDepartment.Out]);

    return;
};
